import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { empty_pagination } from '../../constants/empty_pagination';
import Agent from '../agent';

const initialState = {
  loading: false,
  assets: { tokens: [], protocols: [] },
  pagination: { pages: 0 },
  errors: {},
};

// These are redux/toolkit async thunk for performing api call
// There methods are automatically attached to reducers and actions below
export const getAssets = createAsyncThunk(
  'defi/account/assets/get',
  async (payload, { rejectWithValue }) => {
    try {
      const { data } = await Agent.Defi.Assets.get(payload);
      return data;
    } catch (err) {
      let error = err;
      if (!error.response) {
        return rejectWithValue({ errors: { [err.name]: err.message } });
      }
      return rejectWithValue(error.response.body);
    }
  }
);

const assetSlice = createSlice({
  name: 'defi',
  initialState,
  reducers: {
    setLoading(state) {
      state.loading = true;
    },
  },
  extraReducers: {
    // these are the actions generated by the above createAsyncThunk of redux/toolkit
    [getAssets.pending]: (state) => {
      state.loading = true;
    },

    [getAssets.fulfilled]: (state, action) => {
      state.loading = false;
      let assets = action?.payload?.assets || [];
      let pagination = action?.payload?.pagination || empty_pagination;

      state.assets = pagination.currentPage > 1 ? [...state.assets, ...assets] : assets;

      state.pagination =
        pagination.currentPage > (state.pagination.currentPage || 0)
          ? pagination
          : state.pagination;
    },

    [getAssets.rejected]: (state, action) => {
      state.loading = false;
      state.errors = action?.payload?.errors || {};
    },
  },
});

export const defiAssetSelector = (state) => state.defiAsset;

export const { reducer, actions } = assetSlice;
